/**
 *
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsLabelSrvc', [
    function() {
      this.labels = [];
      var self = this;
      this.develop = true;
      this.loading = true;
      this.labelsPronte;

      this.getLabel = function(label) {
        var res = self.labels[label];
        if (!res) {
          res = '';
          if (self.develop) {
            res += ' [' + label + ']';
          }
        }
        return res;
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/labelSrvc.js
// module id = 5
// module chunks = 0